<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox" @submit.prevent="submit1">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
              v-model="INPUT"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 活动动态 -->
      <div class="newsBlock container">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>活动动态</span>
          <img src="../assets/zszs2.png" />
        </div>
        <div class="cont">
          <ul class="newsList" v-if="actvList.length > 0">
            <li
              class="news-item"
              v-for="(item, index) in actvList"
              :key="index"
              @click="openDetails(item.DB_INFORMATION_ID)"
            >
              <div class="left">
                <img :src="item.INFO_IMG" />
              </div>
              <div class="right">
                <div class="newsInfo">
                  <p class="time">{{ item.CREATEDATE }}</p>
                  <p class="name">{{ item.INFO_TITLE }}</p>
                  <ul class="detail">
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
                <div class="line"></div>
                <div class="seeBtn"><span>查看详情</span></div>
              </div>
            </li>
          </ul>
          <div class="searchResult" v-if="actvList.length == 0">
            暂无活动列表！
          </div>
        </div>
        <div class="pagesBlock1" v-if="sumPages > 1">
          <flPagination
            :totalPage="sumPages"
            :current="1"
            @on-change="handlePageChange"
          ></flPagination>
        </div>
      </div>

      <!-- 提醒弹窗 -->
      <div class="modal-bg" v-if="isShow4">
        <div class="modal-container">
          <div class="modal-top">
            <p class="modal-title">信息</p>
            <img
              src="../assets/cancel.png"
              class="close"
              @click="hideModal()"
            />
          </div>

          <div class="modal-main">{{ message }}</div>
          <div class="modal-bottom">
            <p class="confirmBtn" @click="hideModal">确定</p>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>
/* 标题 */
.toptitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  line-height: 1.875rem;
  font-size: 1.9375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e2e2e;
  margin: 4.375rem 0 3.125rem;
}

.toptitle img {
  width: 4.8125rem;
  height: 0.875rem;
}

.toptitle span {
  margin: 0 1.3125rem;
}

/* 新闻列表 */
.newsBlock {
  position: relative;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 2.5rem;
}

.searchResult {
  width: 100%;
  line-height: 1.5rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #333;
  margin: 2rem 0;
}

.news-item {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1.875rem;
}

.news-item:hover .name {
  font-weight: bold;
}

.news-item .left {
  width: calc(40% - 1.6875rem);
  height: 13.75rem;
  margin-right: 1.6875rem;
  padding: 0;
}

.news-item .left img {
  width: 100%;
  height: 100%;
}

.news-item .right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 60%;
  font-family: Microsoft YaHei;
  text-align: left;
  font-weight: 400;
  color: #333333;
  padding: 0;
}

.news-item .right .newsInfo {
  width: 100%;
}

.time {
  line-height: 0.75rem;
  font-size: 1rem;
  margin-bottom: 1.1875rem;
}

.name {
  width: 100%;
  line-height: 1.5625rem;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.detail {
  display: flex;
  align-items: center;
  margin-bottom: 2.6875rem;
}

.detail li {
  width: 2px;
  height: 2px;
  background: #707070;
  border-radius: 50%;
  margin-right: 2px;
}

.line {
  width: 100%;
  height: 1px;
  background: #bebebe;
  margin-bottom: 0.9375rem;
}

.seeBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 7.6875rem;
  height: 2.625rem;
  line-height: 0.875rem;
  font-size: 0.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5d5d5d;
  border: 1px solid #5d5d5d;
}

.seeBtn span {
  height: 0.875rem;
}

/* 分页 */
.pagesBlock1 {
  position: absolute;
  bottom: 0.625rem;
  right: 0;
  width: 100%;
  margin-bottom: 0;
}

.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.modal-container {
  width: 17.5rem;
  border-radius: 0.3125rem;
  background: #fff;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.625rem;
  box-sizing: border-box;
}

.modal-top .close {
  width: 0.9375rem;
  height: 0.9375rem;
}

.modal-main {
  text-align: left;
  padding: 1.25rem 2.5rem;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: 1.25rem;
  margin-bottom: 0.9375rem;
  box-sizing: border-box;
}

.confirmBtn {
  line-height: 0.875rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  background: #020e62;
  padding: 0.625rem 1.25rem;
}

@media (max-width: 980px) {
  .name {
    line-height: 1.45rem;
    font-size: 1.4rem;
    margin-bottom: 1.8rem;
  }

  .detail {
    display: flex;
    align-items: center;
    margin-bottom: 2.2rem;
  }
}

@media (max-width: 992px) {
  .newsBlock {
    width: 94% !important;
    margin-left: 3% !important;
    max-width: 900px !important;
  }

  .name {
    line-height: 1.25rem;
    font-size: 1.2rem;
    margin-bottom: 1.6rem;
  }

  .detail {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
  }
}

@media (max-width: 770px) {
  .newsBlock {
    width: 90% !important;
    margin-left: 5% !important;
    margin-right: 5% !important;
  }

  .name {
    line-height: 1.25rem;
    font-size: 1.2rem;
    margin-bottom: 1.6rem;
  }

  .detail {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
  }
}

@media (max-width: 600px) {
  .newsBlock {
    width: 90% !important;
    margin-left: 5% !important;
    margin-right: 5% !important;
  }

  .news-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .news-item .left,
  .news-item .right {
    width: 100% !important;
    padding: 0 2%;
    box-sizing: border-box;
  }

  .news-item .left {
    width: 80%;
    margin-right: 0;
    margin-bottom: 1.6875rem;
  }

  .name {
    line-height: 1.25rem;
    font-size: 1.1rem;
    margin-bottom: 1.6rem;
  }

  .detail {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
  }
}

@media (max-width: 499px) {
  .newsBlock {
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .searchResult {
    width: 100%;
    padding: 0 2%;
    box-sizing: border-box;
  }

  .news-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0.4rem;
  }

  .news-item .left,
  .news-item .right {
    width: 100% !important;
    padding: 0 2%;
    box-sizing: border-box;
  }

  .news-item .left {
    width: 80%;
    margin-right: 0;
    margin-bottom: 1.6875rem;
  }

  .name {
    line-height: 1.25rem;
    font-size: 1.1rem;
    margin-bottom: 1.6rem;
  }

  .detail {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
  }
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import flPagination from "@/components/Pagination.vue";
import { getBackground, getNews } from "../api/interface"; // 引入接口
export default {
  name: "newsView",
  components: {
    bottomFooter,
    flPagination,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      INPUT: "",
      PULLNUM: 1, //当前页，起始值是1
      actvList: [],
      sumPages: 0, //总共几页
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
      message: "",
      isShow4: false, //是否展示消息弹窗
    };
  },

  created() {
    this.getImg();
    this.getNews();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;

      console.log("scrollTop", scrollTop);

      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "news-update" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 是否展示消息弹窗
    hideModal() {
      this.$set(this, "isShow4", false);
    },

    // 提交表单
    submit1(e) {
      e.preventDefault(); // 阻止默认提交行为
      console.log(this.INPUT);
      if (this.INPUT == "") {
        this.$set(this, "message", "请输入关键词！");
        this.$set(this, "isShow4", true);
      }
      this.getNews();
    },

    // 获取新闻列表
    async getNews() {
      const that = this;
      await getNews({ INPUT: that.INPUT, PULLNUM: that.PULLNUM }).then(
        (res) => {
          console.log(res);
          that.$set(that, "sumPages", res.page.totalPage);
          that.$set(that, "PULLNUM", res.page.currentPage);
          let actvList = res.information;
          actvList.forEach((v) => {
            v[`isOpen`] = false;
          });
          that.$set(that, "actvList", actvList);
        }
      );
    },

    // 去新闻详情
    openDetails(id) {
      console.log("点击的新闻id是：" + id);
      this.$router.push({ path: "/newsDetail", query: { id: id } });
    },

    // 页码变更
    handlePageChange(page) {
      const that = this;
      console.log("当前页码：" + page);
      that.$set(that, "PULLNUM", page);
      that.getNews();
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
